import React from 'react'

const NavLinkFirstLevel = ({label}) => {
  return (
    <span className='flex w-full items-center justify-between text-purple-900'>
      {label}
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='16 * 16'>
          <path
            id='Vector'
            d='M8.63393 13.2797L14.034 7.92955L8.77612 2.72026M1.96606 7.92722L13.8361 7.92722'
            stroke='#280C2D'
            strokeLinecap='round'
          />
        </g>
      </svg>
    </span>
  )
}

export default NavLinkFirstLevel
